import {
    RejectionReasonCategory,
    REJECTION_REASON_CATEGORY_LABEL,
} from "@models/location";

// The rejection fields as either model carries them: LocationResponse leaves
// them out, and the organization's Location model sends null.
interface RejectionFields {
    rejectionReasonCategory?: RejectionReasonCategory | null;
    rejectionReasonNotes?: string | null;
}

// A rejected location's status line, for the pending wall's resubmit card and
// the Account › Locations row (OB-09): "Rejected", "Rejected: <category>",
// "Rejected: <category> — <notes>" or "Rejected: <notes>". The reviewer's notes
// are never dropped: they are often the one instruction the customer needs to
// fix the resubmit, so a category this build cannot name does not hide them.
export const rejectionLine = ({
    rejectionReasonCategory,
    rejectionReasonNotes,
}: RejectionFields): string => {
    // null (the organization model) and a missing field both mean None.
    const category = rejectionReasonCategory ?? RejectionReasonCategory.None;
    // None's label is "—", not a reason. A value with no label is one this
    // build does not know; it looks up as undefined and names nothing.
    const label =
        category === RejectionReasonCategory.None
            ? undefined
            : REJECTION_REASON_CATEGORY_LABEL[category];

    const reason = [label, rejectionReasonNotes].filter(Boolean).join(" — ");

    return reason ? `Rejected: ${reason}` : "Rejected";
};
